export default function QuestionComplete() {
	return (
		<div>
			<p
				style={{
					fontSize: '20px',
					color: '#525252',
					paddingTop: '4px',
					paddingBottom: '15px',
				}}
			>
				Agradecemos el tiempo que tomaste para responder este cuestionario; tus
				respuestas nos ayudarán a proporcionar un mejor servicio.
			</p>
		</div>
	);
}
